import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "store/actions";

const toMenuDashboard = ({ id, name }) => ({ id, name });

const initialState = {
  dashboards: [],
  // Lightweight { id, name } list for the header's Dashboard menu.
  menuDashboards: [],
  widgets: [],
  isLoading: false,
};

const manageDashboardsSlice = createSlice({
  name: "manageDashboards",
  initialState,
  extraReducers: (builder) => builder.addCase(resetStore, () => initialState),
  reducers: {
    setDashboards: (state, action) => {
      state.dashboards = action.payload || [];
      state.menuDashboards = state.dashboards.map(toMenuDashboard);
    },
    setMenuDashboards: (state, action) => {
      state.menuDashboards = (action.payload || []).map(toMenuDashboard);
    },
    upsertMenuDashboard: (state, action) => {
      const dashboard = toMenuDashboard(action.payload);
      const index = state.menuDashboards.findIndex(
        ({ id }) => id === dashboard.id
      );
      if (index === -1) state.menuDashboards.push(dashboard);
      else state.menuDashboards[index] = dashboard;
    },
    setWidgets: (state, action) => {
      state.widgets = action.payload || [];
    },
    setDashboardsLoading: (state, action) => {
      state.isLoading = Boolean(action.payload);
    },
    removeDashboard: (state, action) => {
      state.dashboards = state.dashboards.filter(
        (dashboard) => dashboard.id !== action.payload
      );
      state.menuDashboards = state.menuDashboards.filter(
        (dashboard) => dashboard.id !== action.payload
      );
    },
  },
});

export const {
  setDashboards,
  setMenuDashboards,
  upsertMenuDashboard,
  setWidgets,
  setDashboardsLoading,
  removeDashboard,
} = manageDashboardsSlice.actions;

export const selManagedDashboards = (state) =>
  state.manageDashboards.dashboards;
export const selMenuDashboards = (state) =>
  state.manageDashboards.menuDashboards;
export const selDashboardWidgetOptions = (state) =>
  state.manageDashboards.widgets;
export const selManagedDashboardsLoading = (state) =>
  state.manageDashboards.isLoading;

const reducer = {
  manageDashboards: manageDashboardsSlice.reducer,
};

export default reducer;
